import { ComponentPropsWithoutRef } from "react";
import styled from "styled-components";

const Section = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	margin-top: 48px;
`;

const ContainerSection = (props: ContainerSectionProps) => {
	return <Section {...props} />;
};
export default ContainerSection;
export interface ContainerSectionProps
	extends ComponentPropsWithoutRef<"div"> {}
